import { fetchGetChatId } from 'shared/repositories/cpd/v1/get-chat-id';

import type { IGetChatIdParams, TGetChatIdResponse } from './types';
import { mappers } from './utils';

export const getChatId = async (params: IGetChatIdParams): Promise<TGetChatIdResponse> => {
  const { httpApi, logger, parameters } = params;

  try {
    const response = await fetchGetChatId({ httpApi, parameters, mappers });

    return response as TGetChatIdResponse;
  } catch (error) {
    logger.error(error, {
      description: 'Ошибка получения chatId CPD /cpd/v1/get-chat-id/',
    });

    return {
      chatId: null,
      isSuccess: false,
    } as TGetChatIdResponse;
  }
};
